import HomeSearch from "../../components/elements/HomeSearch"
import Container from "../../layout/Container"
import Navbar from "../../layout/Navbar"
import Banner from '../../assets/images/hero.png'
import Icon from "../../components/Icon"
import { faArrowUpFromBracket, faLocationDot } from "@fortawesome/free-solid-svg-icons"
import TourCard from "../../components/cards/TourCard"
import OfferCard from "../../components/cards/OfferCard"
import { Link, useParams } from "react-router-dom"

import { useFetch } from '../../hooks/useFetch'
import { getTourEventDetails, getToursAndEvents } from "../../apis"
import useWidth from "../../hooks/useWidth"
import MobileHeader from "../../layout/MobileHeader"
import MobileHeaderSearch from "../../components/MobileHeaderSearch"
import Loader from "../../components/elements/Loader"
import ImageSlider from "../../components/elements/ImageSlider"
import { SwiperSlide } from "swiper/react"
import Share from "../../components/elements/Share"


export default () => {
    const params = useParams()
    const width = useWidth()
    const [details,,loading] = useFetch(getTourEventDetails, {}, params.tourId)
    const [toursAndEvents] = useFetch(getToursAndEvents, {})


    return (
        <>
        <Loader loading={loading} />

            {
                width > 992 ? <Navbar gradient />
                : <MobileHeader>
                    <MobileHeaderSearch placeholder="Search Tour& Events" />
                </MobileHeader>
            }
            
            <Container>
                 <section className="mobile-top-space desktop-top-space">
                    <div className="">
                        {width > 992 && <div className="d-flex justify-content-center flex-column align-items-center ">
                            <h1 className="custom-heading xx-bold">Search Result</h1>
                            <HomeSearch placeholder="Search Tour& Events" />
                        </div>}
                    </div>
                </section>

                <section className="mt-5">
                    <div className="d-flex">
                        <h2 className="custom-text-color">{ details.title }</h2>
                        <Share title={details.title} text={details.shareDescription || details.description} url={details.files?.at(0)?.Url } />
                    </div>

                    {width > 992 ? <div className="row mt-5">
                        <div className="col-lg-9 col-md-12">
                            <div style={{ width: "100%", height: "400px" }}>
                                <img src={details.files?.at(0)?.Url || Banner} className="w-100 h-100 rounded-4 image-cover" />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4">
                            <div className="row">
                                {<div className="col-12 p-0">
                                    <div className="p-2" style={{ width: "100%", height: "200px" }}>
                                        <img src={details.files?.at(1)?.Url || Banner} className="rounded-4 w-100 h-100 image-cover" />
                                    </div>
                                </div>}
                                {<div className="col-12 p-0">
                                    <div className="p-2" style={{ width: "100%", height: "200px" }}>
                                        <img src={details.files?.at(2)?.Url || Banner} className="rounded-4 w-100 h-100 image-cover" />
                                    </div>
                                </div>}
                            </div>
                        </div>

                    </div>
                        :
                        <ImageSlider pagination={{ clickable: true }}>
                            {
                                details?.files?.map((file, i) =>
                                    <SwiperSlide key={i}>
                                        <div style={{ height: "250px" }}>
                                            <img src={file?.Url} className="w-100 h-100 image-cover rounded-3" />
                                        </div>
                                    </SwiperSlide>
                                )
                            }
                        </ImageSlider>

                    }



                </section>

                <section className="row mt-4 p-0">
                    <div className="col-lg-8 col-md-12">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="d-flex m-2">
                                    <div className="mb-0 bg-light-danger-box  rounded d-flex flex-column align-items-center justify-content-center p-3" style={{ width: "60px", height: "60px" }}>
                                        <h4 className="mb-0">{ new Date(details.start_from)?.getDate() }</h4>
                                        <p className="mb-0 fs-9">{ new Date(details.start_from)?.toLocaleString('default', { month: 'long' }) }</p>
                                    </div>
                                    <p className="mb-0 ms-2 fs-8">{ details.departure_from }</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="d-flex m-2">
                                    <div className="mb-0 bg-light-danger-box  rounded d-flex flex-column align-items-center justify-content-center p-3" style={{ width: "60px", height: "60px" }}>
                                        <Icon icon={faLocationDot} className="fs-3" />
                                    </div>
                                    <div>
                                        <p className="mb-0 ms-2 fs-8">{ details.cityId?.name }</p>
                                        <p className="mb-0 ms-2 fs-9 text-primary">See on map</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className="mt-5">{ details.description }</p>
                    </div>
                    <div className="col-lg-4 col-md-12">
                        <div className="card rounded-4">
                            <div className="border-bottom text-center">
                                <p className="mb-0 p-2">Travel Details</p>
                            </div>
                            <div className="fs-8 p-3">
                                <div className="d-flex justify-content-between align-items-center ">
                                    <p className="mb-1 bold">Departure From:</p>
                                    <p className="mb-1">{ details.departure_from }</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center ">
                                    <p className="mb-1 bold">Departure Date:</p>
                                    <p className="mb-1">12/June/2024</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center ">
                                    <p className="mb-1 bold">Package Cost:</p>
                                    <p className="mb-1">₹{ details.cost} per person</p>
                                </div>
                                <div className="d-flex justify-content-between align-items-center ">
                                    <p className="mb-1 bold">Duration:</p>
                                    <p className="mb-1">{ details.duration } Days</p>
                                </div>
                            </div>

                            <button className="primary-btn m-4">Book Now</button>
                        </div>
                    </div>

                </section>

                <div className="container mt-5 d-flex justify-content-between align-items-center">
                    <h3 className='text-saffron'>More Events & Tours</h3>
                    <Link to={'/tours-events'} className='secondary-btn text-nowrap'>View All</Link>
                </div>
                <section className=' mt-5'>

                    <div className='row d-flex gap-2 overflow-auto mt-5 w-100 flex-nowrap scrollbar-hidden p-0 m-0'>
                        {
                            toursAndEvents.allEventsTours?.map(( data, i ) =>
                                <div className='col-lg-4 col-md-4 col-sm-12 p-0' key={i}>
                                    <TourCard data={data} />
                                </div>
                            )
                        }

                    </div>
                </section>


                <div className="offers">
                <div className="row mx-0 px-5 pt-5">
                    <div className="col-md-8 p-0">
                        <div className="top-heading">Offers Tailored For You</div>
                    </div>
                    <div className="col-md-4 d-flex justify-content-end">
                        <Link to={'/offers'} className="view-all w-50">Know More</Link>
                    </div>
                </div>

                <div className="row  mx-0 my-5 ">
                    <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
                        <li className="m-2">
                            <div className="bg-dark rounded offers-card-container">
                                <OfferCard data={"Get upto 15% off on your First Booking"} />
                            </div>
                        </li>

                        <li className="m-2">
                            <div className="bg-dark rounded offers-card-container">
                                <OfferCard data={"Budget Friendly Homestays"} />
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
            </Container>
        </>
    )
}